// extracted by mini-css-extract-plugin
export default {"divider":"divider_divider__BjsXT","noBorder":"divider_noBorder__VyZg0"};